import { OutputData } from "@editorjs/editorjs";
import { useState } from "react";
import useUndo from "use-undo";

export function useJsonEditor() {
  const [
    editorData,
    {
      set: setEditorData,
      reset: resetEditorData,
      undo: undoEditorData,
      redo: redoEditorData,
      canUndo,
      canRedo,
    },
  ] = useUndo<OutputData | null>(null);
  const [searchQuery, setSearchQuery] = useState("");
  return {
    editorData,
    setEditorData,
    resetEditorData,
    searchQuery,
    setSearchQuery,
    historyConfig: {
      canUndo,
      canRedo,
      undo: undoEditorData,
      redo: redoEditorData,
    },
  };
}
